var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Type } from 'class-transformer';
import { BaseNumberIdDataDto } from '../../../classes/common/response/base-number-id-data.dto';
import { InsuranceForD2CDto } from '../../../classes/insurance';
import { VehicleModelAudioDto } from './vehicle-model-audio.dto';
import { VehicleModelInsuranceDto } from './vehicle-model-insurance.dto';
import { VehicleModelKeyOptionDto } from './vehicle-model-key-option.dto';
import { VehicleModelOptionDto } from './vehicle-model-option.dto';
export class VehicleModelWithInsurancesForD2CDto extends BaseNumberIdDataDto {
    constructor(initializer) {
        super(initializer);
        this.companyId = initializer.companyId;
        this.name = initializer.name;
        this.title = initializer.title;
        this.type = initializer.type;
        this.fuel = initializer.fuel;
        this.seat = initializer.seat;
        this.transmission = initializer.transmission;
        this.drivingSystem = initializer.drivingSystem;
        this.driverAge = initializer.driverAge;
        this.driverExperience = initializer.driverExperience;
        this.keyOption = initializer.keyOption;
        this.modelOption = initializer.modelOption;
        this.audio = initializer.audio;
        this.imageUrls = initializer.imageUrls;
        this.availableWithInsuranceOption1 =
            initializer.availableWithInsuranceOption1;
        this.availableWithInsuranceOption2 =
            initializer.availableWithInsuranceOption2;
        this.totalCount = initializer.totalCount;
        this.availableCount = initializer.availableCount;
        this.minModelYear = initializer.minModelYear;
        this.maxModelYear = initializer.maxModelYear;
        this.referencePrice = initializer.referencePrice;
        this.branchNames = initializer.branchNames;
        this.insurance1 = initializer.insurance1;
        this.insurance2 = initializer.insurance2;
        this.insurances = initializer.insurances;
    }
}
__decorate([
    Type(() => VehicleModelKeyOptionDto),
    __metadata("design:type", VehicleModelKeyOptionDto)
], VehicleModelWithInsurancesForD2CDto.prototype, "keyOption", void 0);
__decorate([
    Type(() => VehicleModelOptionDto),
    __metadata("design:type", VehicleModelOptionDto)
], VehicleModelWithInsurancesForD2CDto.prototype, "modelOption", void 0);
__decorate([
    Type(() => VehicleModelAudioDto),
    __metadata("design:type", VehicleModelAudioDto)
], VehicleModelWithInsurancesForD2CDto.prototype, "audio", void 0);
__decorate([
    Type(() => VehicleModelInsuranceDto),
    __metadata("design:type", Object)
], VehicleModelWithInsurancesForD2CDto.prototype, "insurance1", void 0);
__decorate([
    Type(() => VehicleModelInsuranceDto),
    __metadata("design:type", Object)
], VehicleModelWithInsurancesForD2CDto.prototype, "insurance2", void 0);
__decorate([
    Type(() => InsuranceForD2CDto),
    __metadata("design:type", Array)
], VehicleModelWithInsurancesForD2CDto.prototype, "insurances", void 0);
